import '@modules/legend-element';

export default (ctx, html) => html`
  <legend-element .legend=${ctx.legend} class="font-size-small"></legend-element>
`;
